import NavLink from '../NavLink';
import {useMainMenuContext} from '../../contexts/MainMenuContext';
import * as React from "react";
import clsx from 'clsx';
import NavGroup from '../nav-group/NavGroup';
import NavigationIcon from '../navigation-icon/NavigationIcon';
import theme from "./theme.module.scss";

interface INavLinkGroupProps {
    children?: any
    to?: string;
    label?: string;
    iconName?: string;
    right?: boolean;
    group?: string;
}

export default function NavLinkGroup({children, to, label, iconName, right, group}: INavLinkGroupProps) {
    const {selectedGroup, setSelectedGroup} = useMainMenuContext();
    const groupName = label || group;
    const hasChildren = React.Children.toArray(children).some(React.isValidElement);
    const isOpen = hasChildren && groupName === selectedGroup;
    return (
        <div
            className={theme.navLinkGroup}
            onMouseEnter={() => setSelectedGroup(groupName)}
            onMouseLeave={() => setSelectedGroup(null)}
            onFocusCapture={() => setSelectedGroup(groupName)}
            onBlurCapture={event => {
                if (!event.currentTarget.contains(event.relatedTarget as Node)) setSelectedGroup(null);
            }}
            onClick={() => setSelectedGroup(null)}
            onKeyDown={event => {
                if (event.key === 'Escape') {
                    (event.currentTarget.querySelector(':scope > a') as HTMLElement)?.focus();
                    setSelectedGroup(null);
                }
            }}>
            {to ? (
                <NavLink className={theme.navLinkGroupInside} to={to} aria-expanded={hasChildren ? isOpen : undefined}>
                    {iconName &&
                        <NavigationIcon style={{marginRight: label ? '.8rem' : 0}} iconName={iconName}/>}
                    <span className={theme.label}>{label.toUpperCase()}</span></NavLink>
            ) : label ? (
                <div className={theme.navLinkGroupInside}>
                    {iconName &&
                        <NavigationIcon style={{marginRight: label ? '.8rem' : 0}} iconName={iconName}/>}
                    <span className={theme.label}>{label.toUpperCase()}</span>
                </div>
            ) : null}

            {isOpen ? (
                <div role="region" aria-label={`${groupName} menu`} className={clsx(theme.dropdown, {[theme.right]: right})}>
                    <NavGroup>
                        {children}
                    </NavGroup>
                </div>
            ) : null}
        </div>
    );
}
